import { jsx as _jsx } from "react/jsx-runtime";
import TextField from '@mui/material/TextField';
import { colorTokens } from '../theme/tokens';
const INPUT_SX = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '12px',
        backgroundColor: colorTokens.white,
        '&:not(.MuiInputBase-multiline) .MuiInputBase-input': {
            padding: '8px 12px',
            fontSize: 12,
            fontWeight: 400,
            height: 'auto',
            lineHeight: '16px',
            boxSizing: 'border-box',
            color: colorTokens.gray800,
        },
        '& .MuiInputBase-input::placeholder': {
            color: colorTokens.gray600,
            opacity: 1,
            fontSize: 12,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: colorTokens.borderLight,
            borderWidth: '1px',
            borderRadius: '12px',
        },
        '&:hover .MuiOutlinedInput-notchedOutline, &:hover:not(.Mui-focused):not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
            borderColor: colorTokens.borderLight,
            borderWidth: '1px',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colorTokens.borderLight,
            borderWidth: '1px',
        },
        '&.Mui-focused': {
            boxShadow: 'none',
        },
        '&.Mui-disabled': {
            backgroundColor: colorTokens.gray50,
        },
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: colorTokens.gray200,
            borderWidth: '1px',
        },
        '&.Mui-disabled .MuiInputBase-input': {
            color: colorTokens.gray400,
            WebkitTextFillColor: colorTokens.gray400,
            cursor: 'not-allowed',
        },
    },
};
export const AppInput = ({ fullWidth = true, sx, ...rest }) => (_jsx(TextField, { variant: "outlined", size: "small", fullWidth: fullWidth, sx: [INPUT_SX, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])], ...rest }));
